<template>
	<loading-icon class="c-card" v-if="loading"></loading-icon>
  <section :class="{ 'c-card qa-multicard': hasMultipleCards }" v-else>
	  <div v-if="hasMultipleCards" class="c-card__multicard-header">

      <menu class="c-card__multicard-header__menu qa-multicard-dropdown">
        <menuitem
          @click = "toggleDropdown"
          class  = "c-card__multicard-header__menu__default t-headline qa-multicard-menu-button"
          :class = "showDropdown == true ? 'is-open' : ''"
        >
          <span>{{ card.title }}: {{ currentCard.title }}</span>
          <i class="fa fa-sort-down"></i>
        </menuitem>

        <div
          v-if  = "showDropdown"
          class = "c-card__multicard-header__menu__itemgroup"
        >
          <menuitem
            v-for  = "(card, index) in card.card_layout"
            v-if   = "typeof cards[card.id] !== 'undefined'"
            @click = "select(index)"
            class  = "c-card__multicard-header__menu__menuitem qa-multicard-menuitem"
            :class = "showDropdown == true ? 'is-open' : ''"
          >
            <span>{{ cards[card.id].title }}</span>
            <i v-show="index === currentCardIndex" class="fa fa-check t-headline"></i>
          </menuitem>
        </div>
      </menu>

	  </div>

    <component
      v-if    = "typeof currentCard !== 'undefined' && typeof currentCard.id !== 'undefined'"
      :key    = "currentCard.id"
      :is     = "'card-'+currentCard.type"
      :card   = "currentCard"
      :loaded = "!loading"
      class = "qa-multicard-current">
    </component>

  </section><!--END CARD-->

</template>




<script>
import { mapGetters } from 'vuex'
import _ from 'lodash'

export default {
  name: 'MultiCard',

  props: ['card'],

  data () {
    return {
      baseUrl: '',
      currentCardIndex: 0,
      showDropdown: false
    }
  },

  computed: {
    ...mapGetters({
      cards: 'cards'
    }),

    currentCard () {
      // Set the default card
      if (this.cards[this.card.card_layout[this.currentCardIndex].id]) {
        return this.cards[this.card.card_layout[this.currentCardIndex].id]
      }
      return {}
    },

    loading () {
      // If the first card (default card) is already loaded then we are good to remove the loading
      if (this.card.cardLoaded && typeof this.card.card_layout !== 'undefined') {
        return !(typeof this.cards[this.card.card_layout[this.currentCardIndex].id] !== 'undefined' && this.cards[this.card.card_layout[this.currentCardIndex].id].cardLoaded)
      }
      return !this.card.cardLoaded
    },

    /**
     * Returns if the card has more than one card or has multiple, if only have one card,
     * then only one single card should be displayed without the dropdown/buttons
     * @returns {boolean}
     */
    hasMultipleCards () {
      if (typeof this.card.card_layout !== 'undefined') {
        return this.card.card_layout.length > 1
      }
      return false
    }
  },

  methods: {
    loadCards () {
      if (typeof this.card.card_layout !== 'undefined') {
        _.each(this.card.card_layout, (card, i) => {
          if (typeof this.cards[card.id] === 'undefined' && !card.loading) {
            this.$store.dispatch('LOAD_CARD', {id: card.id})
            // Set loading property to avoid extra API requests
            this.card.card_layout[i].loading = true
          }
        })
      }
    },

    /**
     * Toggle the dropdown state.
     *
     * @return {void}
     */
    toggleDropdown () {
      this.showDropdown = !this.showDropdown
    },

    /**
     * Select a card to display.
     *
     * @param {Number} index Index of card in this.card.card_layout.
     * @return {void}
     */
    select (index) {
      this.toggleDropdown()
      this.currentCardIndex = index
    }
  },

  updated () {
    this.loadCards()
  },

  mounted () {
    this.loadCards()
  }
}
</script>



// WEBPACK FOOTER //
// MultiCard.vue?21fd4e37